import { useEffect, useState } from 'react';
import { DocumentHtmlDataModel } from '../../../models/document.html.data.model';
import {
  fetchDocumentUploadHTML,
  selectAllDocumentUploadHTML,
} from '../../../slices/document-upload-html/documentUploadHTMLSlice';
import { useAppSelector } from '../../../common/hooks/useAppSelector';
import { useAppDispatch } from '../../../common/hooks/useAppDispatch';
import { NWClient } from '../../../client/NWClient';
import { toast } from 'react-toastify';
import { UseDocumentDetailsProps } from '../types';
import { useErrorMessage } from '../../../common/hooks/useErrorMessage';

export const useDocumentVersions = ({
  id,
  isDocumentContract,
  allowedGettingVersions,
}: UseDocumentDetailsProps) => {
  const { getErrorMessage } = useErrorMessage();
  const dispatch = useAppDispatch();
  const documentUploadHTMLArray = useAppSelector(selectAllDocumentUploadHTML);
  const [versionHTML, setVersionHTML] = useState<string | null>(null);
  const [pendingStatus, setPendingStatus] = useState<boolean>(false);
  const [versionModalOpened, setVersionModalOpened] = useState<boolean>(false);

  const versionsArray = [...documentUploadHTMLArray]
    .filter((el) => el.document_upload === id)
    .sort()
    .reverse();

  const getDocumentUploadHTML = (id: number) => {
    setPendingStatus(true);
    setVersionHTML(null);
    NWClient.get<DocumentHtmlDataModel>('document-upload-html-data', id)
      .then((res) => {
        setVersionHTML(res.html);
      })
      .catch((error) => {
        toast.error(getErrorMessage(error));
      })
      .finally(() => setPendingStatus(false));
  };

  useEffect(() => {
    if (id && isDocumentContract !== undefined && !isDocumentContract && allowedGettingVersions) {
      dispatch(fetchDocumentUploadHTML({ data: { document_upload: Number(id) } }));
    }
  }, [id, isDocumentContract, allowedGettingVersions, dispatch]);

  return {
    setVersionHTML,
    versionHTML,
    pendingStatus,
    getDocumentUploadHTML,
    setVersionModalOpened,
    versionModalOpened,
    versionsArray,
  };
};
